//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "transferAuthorizationSuccess",
    data() {
        return {
            detail: {},
            appName: '',
            authTime: ''
        };
    },
    created() {
        this.initData();
    },
    methods: {
        initData() {
            let query = JSON.parse(sessionStorage.getItem("data") || '{}');
            this.detail = { ...query };
            this.appName = query.app_name || query.subject || '服务方';
            this.authTime = this.formatTime(query.auth_time || new Date());
        },
        formatTime(time) {
            let date = time instanceof Date ? time : new Date(time);
            if (isNaN(date.getTime())) {
                date = new Date();
            }
            let y = date.getFullYear();
            let m = String(date.getMonth() + 1).padStart(2, '0');
            let d = String(date.getDate()).padStart(2, '0');
            let h = String(date.getHours()).padStart(2, '0');
            let min = String(date.getMinutes()).padStart(2, '0');
            let s = String(date.getSeconds()).padStart(2, '0');
            return `${y}-${m}-${d} ${h}:${min}:${s}`;
        },
        // 从 window.location.href 中原始提取 redirect_url 的值，
        // 兼容值中包含 #/?... 等导致 Vue Router hash 模式下被截断的场景
        extractRawRedirectUrl() {
            try {
                const href = window.location.href || '';
                const key = 'redirect_url=';
                const idx = href.indexOf(key);
                if (idx < 0) return '';
                // 取到字符串末尾：因为 redirect_url 的值往往自带 # / ?，
                // 浏览器规范决定它之后不可能再出现合法的同级 query，整体即为完整值
                return href.substring(idx + key.length);
            } catch (e) {
                return '';
            }
        },
        goWithdraw() {
            const rawQuery = this.$route.query || {};
            // 1. 优先用原始 href 提取，避免值中含 #/?... 被 router 截断
            let redirect_url = this.extractRawRedirectUrl() || rawQuery.redirect_url;
            console.log('redirect_url', redirect_url);
            if (!redirect_url) return;

            // 2. 兼容 JSON.stringify 包裹的场景（值带前后引号且不是 URL 编码串）
            if (
                typeof redirect_url === 'string' &&
                redirect_url.indexOf('http') !== 0 &&
                redirect_url.indexOf('%') < 0
            ) {
                try { redirect_url = JSON.parse(redirect_url); } catch (e) { /* ignore */ }
            }

            // 3. 多次 URL 解码（最多 3 次，防止死循环）
            let decoded = String(redirect_url);
            for (let i = 0; i < 3 && decoded.indexOf('%') >= 0; i++) {
                try {
                    const next = decodeURIComponent(decoded);
                    if (next === decoded) break;
                    decoded = next;
                } catch (e) { break; }
            }
            redirect_url = decoded.replace(/^["']|["']$/g, '');

            // 4. 仅当 redirect_url 中不含 # 时，才追加同级 query（# 之后浏览器不会再有合法 query）
            if (redirect_url.indexOf('#') < 0) {
                const extra = Object.keys(rawQuery)
                    .filter(k => k !== 'redirect_url' && rawQuery[k] != null && rawQuery[k] !== '')
                    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(rawQuery[k])}`)
                    .join('&');
                if (extra) {
                    redirect_url += (redirect_url.indexOf('?') >= 0 ? '&' : '?') + extra;
                }
            }

            // 5. 最终校验
            if (typeof redirect_url !== 'string' || redirect_url.indexOf('http') !== 0) {
                console.warn('[transferAuthorizationSuccess] 无效的 redirect_url:', rawQuery.redirect_url);
                return;
            }
            window.location.href = redirect_url;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/transferAuthorization/success.vue